<app-banner [loading]="loading" [info]="true" [heading]="'Exceptional circumstances'"
  [subHeading]="'View the requests for exceptional circumstances received from registrants.'">


  <div class="toolbar-content">

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }

    <button (click)="toggleSearch()" aria-label="Search for requests by registration number" class="btn">
      <i class="fa fa-search"></i>
      <span>search</span>
    </button>

  </div>

</app-banner>

<app-collapsible [trigger]="!searchVisible">
  <div class="content no-boxes form-inline search-bar">

    <div class="form-group reg-number">
      <input #regNumber placeholder="Search Reg Number..." [(ngModel)]="searchCriteria.regNumber" type="text"
        name="regNumber" class="form-control " />
        <button class="btn btn-primary ml-2" [disabled]="!searchCriteria.regNumber" (click)="search()">Search</button>
        <button class="btn btn-default ml-2" (click)="clearSearch()">Clear</button>
      <!--app-utc-date-picker  [(ngModel)]="searchCriteria.date" (ngModelChange)="dateChange($event)" [placeholder]="'choose renewal date'"></app-utc-date-picker>-->
    </div>

    <div class="form-group">
      <span style="font-weight: 600;">Search by renewal date: </span>
      <select style="cursor: pointer;" placeholder="'choose renewal date'" class="form-control" name="renewalDate"
        [(ngModel)]="searchCriteria.renewalDate" (ngModelChange)="onRenewaldateSelected($event)"
        [disabled]="!!searchCriteria.regNumber">
        <option value="undefined">choose renewal date </option>
        @for (item of uniqueRenewalDates; track item) {
          <option [value]="item">
            {{ item | utcDate }}
          </option>
        }
      </select>
    </div>

    <div class="statuses" [class.pointer-event-none]="!tempItems || tempItems.length === 0">
      @for (item of ReviewStatus | keys; track item) {
        <span (click)="filter(item.key)"
          [class.inactive]="!!searchCriteria.regNumber || (searchCriteria.status && item.key !== searchCriteria.status)"
        class="status {{item.value}}">{{ item.value | caseSplit }}</span>
      }
    </div>

    <div class="counter">
      <span>
        {{ numberOfRecordsSelected == 1 ? numberOfRecordsSelected + " request found " : numberOfRecordsSelected + " requests found " }}
        @if (selectedFilter !== '') {
          <span>for </span>
        }
        <strong>{{ selectedFilter | caseSplit }}</strong>
      </span>
    </div>

  </div>
</app-collapsible>

@if (items?.length) {
  <div class="content no-boxes fadein" style="padding:0">
    <table class="table">
      <thead>
        <tr>
          <th style="width: 100px">Status</th>
          <th style="width: 80px">Received</th>
          <th style="width: 100px">Reg #</th>
          <th style="width: 60px">RegistrationStatus</th>
          <th style="width: 80px">Renewal date</th>
          <th style="width: 200px">Name</th>
          <th>Subject</th>
          <th>Assigned to</th>
          <th>on</th>
        </tr>
      </thead>
      <tbody>
        @for (item of items; track item; let i = $index) {
          <tr class="clickable" [class.unassigned]="!item.assignedTo"
            [routerLink]="['/revalidation/extenuating-circumstances', item.id]">
            <td>
              <span class="status {{ReviewStatus[item.reviewStatus]}}">{{ (ReviewStatus[item.reviewStatus] | caseSplit) ||
              'Received' }}</span>
            </td>
            <td> {{ item.submittedAt | utcDate }} </td>
            <td> {{ item.registrationNumber }} </td>
            <td> {{ (RegistrantStatus[item.registrationStatus] | caseSplit) }}</td>
            <td> {{ item.renewalDate | utcDate }} </td>
            <td> {{ item.fullName }} </td>
            <td> {{ item.subject }} </td>
            <td class="assigned-to" (click)="assigningItem = item; $event.stopPropagation()">
              <app-ext-circ-assign [item]="item" (selected)="assigningItem = $event"
              [selecting]="item === assigningItem"></app-ext-circ-assign>
            </td>
            <td>
              @if (item !== assigningItem) {
                <span>{{ item.assignedAt | date: 'dd/MM/yyyy' }}</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
} @else {
  <div class="content no-boxes fadein">
    @if (!items?.length) {
      <div class="no-data">
        There are currently no Exceptional circumstances
      </div>
    }
  </div>
}

